var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListErrorStateIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5082_126538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5082_126538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 68.9108 118.054 77.3757 114.559 84.9811C105.089 105.649 84.2189 120 60 120C35.7811 120 14.9108 105.649 5.44054 84.9811C1.94595 77.3757 0 68.9108 0 60C0 26.8622 26.8622 0 60 0C93.1378 0 120 26.8622 120 60Z",
    fill: "#F4F7FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5082_126538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 84L22.5 79.875L39 86.25L24 94.5L2.625 84Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.375 84L97.5 79.875L81 86.25L96 94.5L117.375 84Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39 86.25H81L96 94.5H24L39 86.25Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0804 50.5793C51.8396 46.6769 60.4825 48.9927 64.3849 55.7519C68.2873 62.5111 65.9714 71.154 59.2123 75.0564L51.2636 79.6455L49.1302 89.2054C48.8672 90.3839 47.2935 90.625 46.6897 89.5793L43.0182 83.22C37.4847 83.994 31.782 81.4235 28.8166 76.2873C24.9142 69.5281 27.23 60.8852 33.9892 56.9828L45.0804 50.5793Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2081,
    cy: 2.2081,
    r: 2.2081,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 54.8672 58.7012)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2081,
    cy: 2.2081,
    r: 2.2081,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 47.2178 63.1191)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2081,
    cy: 2.2081,
    r: 2.2081,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 39.5693 67.5312)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.732 23.6854C58.7161 21.0017 48.4209 26.9456 45.7372 36.9615C43.0534 46.9774 48.9973 57.2726 59.0132 59.9563L70.7933 63.1128L76.8183 74.647C77.561 76.0689 79.6634 75.8372 80.0786 74.2876L82.6037 64.864C89.9703 63.9541 96.4041 58.6946 98.4433 51.0841C101.127 41.0681 95.1832 30.773 85.1673 28.0892L68.732 23.6854Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.0383,
    cy: 41.0617,
    r: 2.93362,
    transform: "rotate(15 61.0383 41.0617)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.3732,
    cy: 44.0968,
    r: 2.93362,
    transform: "rotate(15 72.3732 44.0968)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.7082,
    cy: 47.1379,
    r: 2.93362,
    transform: "rotate(15 83.7082 47.1379)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6949 32.7834C42.2991 32.6386 42.6716 32.0314 42.5268 31.4272C42.382 30.823 41.7748 30.4505 41.1706 30.5953L38.2532 31.2944C37.6489 31.4392 37.2765 32.0464 37.4213 32.6506C37.5661 33.2548 38.1733 33.6273 38.7775 33.4825L41.6949 32.7834ZM52.5119 19.0915C52.5107 19.7128 52.006 20.2155 51.3847 20.2143C50.7634 20.2131 50.2607 19.7084 50.2619 19.0871L50.2678 16.0871C50.269 15.4658 50.7736 14.9631 51.395 14.9643C52.0163 14.9655 52.519 15.4702 52.5178 16.0915L52.5119 19.0915ZM43.1167 26.035C42.9756 26.6401 42.3706 27.0162 41.7656 26.8751L38.844 26.1938C38.2389 26.0526 37.8627 25.4477 38.0038 24.8427C38.1449 24.2376 38.7499 23.8614 39.3549 24.0025L42.2766 24.6839C42.8816 24.825 43.2578 25.4299 43.1167 26.035ZM46.7833 20.528C47.0604 21.0841 46.8343 21.7595 46.2782 22.0367C45.7221 22.3138 45.0467 22.0877 44.7695 21.5316L43.4313 18.8466C43.1542 18.2905 43.3803 17.6151 43.9364 17.3379C44.4925 17.0608 45.1679 17.2869 45.4451 17.843L46.7833 20.528Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 94.5,
    width: 72,
    height: 63,
    fill: "#4C4C4C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5082_126538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListErrorStateIconDark);
export default __webpack_public_path__ + "static/media/list_error_state_icon_dark.76f6cddd9452d2101b74c86c00f55f1e.svg";
export { ForwardRef as ReactComponent };